import { UserAccess } from '@api/types/client-user-management';
import { FilterOption } from '@api/types/common';
import { CLIENT_USER_ROLE, CLIENT_USER_STATUS } from '@api/types/client-user-management';
import { SUBMODULE_TYPE } from '@constants/constants';

const MAX_SEARCH_LENGTH = 256;

export const buildDashboardFilterOptions = (dashboards: UserAccess[]): FilterOption[] =>
  dashboards.map((dashboard) => ({
    label: dashboard.submoduleName,
    value: dashboard.submoduleType,
  }));

export const buildDashboardSelectOptions = (
  role: CLIENT_USER_ROLE,
  dashboards: UserAccess[],
): FilterOption[] => {
  if (role === CLIENT_USER_ROLE.OWNER) {
    return dashboards.map((dashboard) => ({
      label: dashboard.submoduleName,
      value: dashboard.submoduleId,
    }));
  }
  const allDashboardsWithoutManageUsers = dashboards.filter(
    (dashboard) => dashboard.submoduleType !== SUBMODULE_TYPE.CLIENT_USER_MANAGEMENT,
  );
  return allDashboardsWithoutManageUsers.map((dashboard) => ({
    label: dashboard.submoduleName,
    value: dashboard.submoduleId,
  }));
};

export const extractSubmoduleIds = (userAccesses: UserAccess[]): string[] =>
  userAccesses.map((access) => access.submoduleId);

type BuildCompanyUsersQueryParams = {
  pageNumber?: number;
  pageSize?: number;
  sort?: string;
  sortOrder?: string;
  search?: string;
  companyRole?: CLIENT_USER_ROLE | CLIENT_USER_ROLE[];
  status?: CLIENT_USER_STATUS | CLIENT_USER_STATUS[];
  submoduleType?: string;
};

export const buildCompanyUsersQuery = ({
  pageNumber,
  pageSize,
  sort,
  sortOrder,
  search,
  companyRole,
  status,
  submoduleType,
}: BuildCompanyUsersQueryParams): string => {
  const params: string[] = [];

  if (pageNumber !== undefined) params.push(`pageNumber=${pageNumber}`);
  if (pageSize !== undefined) params.push(`pageSize=${pageSize}`);
  if (sort) params.push(`sort=${sort}`);
  if (sortOrder) params.push(`sortOrder=${sortOrder}`);
  if (search) params.push(`search=${search.slice(0, MAX_SEARCH_LENGTH)}`);
  if (companyRole) {
    params.push(`companyRole=${Array.isArray(companyRole) ? companyRole.join(',') : companyRole}`);
  }
  if (status) params.push(`status=${Array.isArray(status) ? status.join(',') : status}`);
  if (submoduleType) params.push(`submoduleType=${submoduleType}`);

  return params.join('&');
};

export const getEmailDomain = (email: string): string | null =>
  email.split('@')[1]?.toLowerCase() ?? null;
